// Übersetzungen [Suomi, English] für das Handy als App: Reiterleiste, Blatt „Mehr“, Gerät, Installieren.
export const APP: Record<string, [string, string]> = {
  'Mehr': ['Lisää', 'More'],
  'Hauptnavigation': ['Päävalikko', 'Main navigation'],
  'Vibrieren, wenn der Gegner zieht': ['Värinä, kun vastustaja siirtää', 'Vibrate when the opponent moves'],
  'Als App installieren': ['Asenna sovelluksena', 'Install as app'],
  'Als App: in Safari „Teilen“, dann „Zum Home-Bildschirm“.': ['Sovelluksena: Safarissa ”Jaa”, sitten ”Lisää Koti-valikkoon”.', 'As an app: in Safari tap “Share”, then “Add to Home Screen”.'],
  'Dieses Gerät': ['Tämä laite', 'This device'],
  'Läuft als installierte App.': ['Toimii asennettuna sovelluksena.', 'Running as an installed app.'],
  'Als App installieren geht in Chrome und Edge über das Menü, sobald der Server über https oder als localhost erreichbar ist.':
    ['Sovelluksena asentaminen onnistuu Chromen ja Edgen valikosta, kun palvelin on tavoitettavissa https-yhteydellä tai localhostina.',
     'Installing as an app works from the Chrome and Edge menu once the server is reached via https or as localhost.'],
  'Handy hochkant': ['Puhelin pystyssä', 'Phone, portrait'],
  'Handy quer': ['Puhelin vaakatasossa', 'Phone, landscape'],
  'Klapphandy aufgeklappt': ['Taittopuhelin auki', 'Foldable, unfolded'],
  'Tablet': ['Tabletti', 'Tablet'],
  'Rechner': ['Tietokone', 'Computer'],
  // Aufrufe
  'Aufrufe': ['Käynnit', 'Visits'],
  'Heute': ['Tänään', 'Today'],
  'Letzte 7 Tage': ['Viimeiset 7 päivää', 'Last 7 days'],
  'Gesamt seit {d}': ['Yhteensä {d} alkaen', 'Total since {d}'],
  'Gesamt': ['Yhteensä', 'Total'],
  'Gezählt wird jedes Laden der Seite auf diesem Server, ohne Adressen oder Cookies. Testläufe und Suchmaschinen zählen nicht.':
    ['Jokainen sivun lataus tällä palvelimella lasketaan, ilman osoitteita tai evästeitä. Testiajot ja hakukoneet eivät lasketa.',
     'Every page load on this server is counted, without addresses or cookies. Test runs and search engines do not count.'],
  'Wird geladen …': ['Ladataan …', 'Loading …'],
};
